var React = require('react');

function IcPoster (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.5 7C5.88071 7 7 5.88071 7 4.5C7 3.11929 5.88071 2 4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88071 3.11929 7 4.5 7ZM5 16.5858V8.97254C7.08581 8.74196 8.74196 7.08581 8.97254 5H19V8.61104L14.3248 13.7113L10.3554 11.2304L5 16.5858ZM5 19.4142V20H19V11.5708L14.6752 16.2888L10.6446 13.7696L5 19.4142ZM4.5 0C6.45933 0 8.12619 1.25221 8.74394 3H21V22H3V8.74394C1.25221 8.12619 0 6.45933 0 4.5C0 2.01472 2.01472 0 4.5 0Z","fill":"black"}));
}

IcPoster.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcPoster;

IcPoster.default = IcPoster;
